import { FC } from 'react';
import { DataGridErrorProps } from './DataGridError.types';
import { AllieText } from '../../../Text';
import { AllieLink } from '../../../Buttons/Link';

export const DataGridError: FC<DataGridErrorProps> = ({
  principalText,
  refreshText,
  refreshFn,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        backgroundColor: 'white',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        padding: 50,
      }}
    >
      <AllieText style={{ margin: 4, marginTop: 24 }} type="h4" weight={600}>
        {principalText}
      </AllieText>
      {refreshFn && (
        <AllieLink
          style={{ marginBottom: 24, marginTop: 8 }}
          icon={'refresh'}
          size={'large'}
          onClick={() => refreshFn()}
        >
          <AllieText style={{ fontWeight: 400 }}>{refreshText}</AllieText>
        </AllieLink>
      )}
    </div>
  );
};
